export const itemContainerStyles =
   'flex items-center px-[8px] py-[4px] outline-none rounded-md'
export const itemLeftIconStyles = 'p-[4px] mr-[8px]'
export const itemTextStyles = 'text-sm-regular'

export const headerContainerStyles = `px-[12px] py-[8px] text-xs-semibold border-b mt-[4px]`
export const headerTextStyles = `text-sm-regular`

export const noDataViewStyles =
   'w-full h-full flex justify-center py-[12px] text-md-medium'

export const pipelinesListContainerStyles =
   'flex flex-col gap-[2px] px-[6px] py-[4px] max-h-[192px]'
